import { withPrefix } from 'gatsby'
import React from 'react'

const ShareSectionBackgroundImages = () => {
    return (
        <div>
            <img className="sh-bg-1" src={withPrefix('/images/share-bg-01.webp')} alt="" />
            <img className="sh-bg-2" src={withPrefix('/images/share-bg-02.webp')} alt="" />
            <img className="sh-bg-3" src={withPrefix('/images/share-bg-03.webp')} alt="" />
            <img className="sh-bg-4" src={withPrefix('/images/share-bg-04.webp')} alt="" />
            <style jsx>{`
                div {
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    top: 0;
                    left: 0;
                    z-index: 1;
                    pointer-events: none;
                }

                img {
                    position: absolute;
                    max-height: 200px;
                }

                .sh-bg-1 {
                    top: 20px;
                    left: 20px;
                }
                .sh-bg-2 {
                    top: 20px;
                    right: 20px;

                }
                .sh-bg-3 {
                    bottom: 20px;
                    left: 20px;
                }
                .sh-bg-4 {
                    bottom: 20px;
                    right: 20px;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    img {
                        display: none;
                    }


                    .sh-bg-3 {
                        display: inline;
                        bottom: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                        max-height: 160px;
                    }
                }
            `}</style>
        </div>
    )
}

export default ShareSectionBackgroundImages